import React from 'react';
import '../styles/resume.css';

const Resume = () => (
	<div>
		<header id="info">
			<h1>Pratik Mishra</h1>
			<span>
				1207 E 8th Street &bull; (480)442-7746 &bull; pratikmishra@asu.edu
			</span>
		</header>
		<section>
			<br />
			<section id="education">
				<h2>Education</h2>
				<div className="edtable">
					<div className="tablerow">
						<span className="jobtitle">
							<strong>Arizona State University, Tempe</strong>
						</span>
						<span className="right">
							<strong>May 2019</strong>
						</span>
					</div>
					<div className="tablerow">
						<span>Computer Science, Master's</span>
						<span className="right">
							<strong />
						</span>
					</div>
				</div>

				<div className="edtable">
					<div className="tablerow">
						<span className="jobtitle">
							<strong>
								International Institute of Infomration Technology, Bhubanneswar
							</strong>
						</span>
						<span className="right">
							<strong>June 2017</strong>
						</span>
					</div>
					<div className="tablerow">
						<span>Information Technology, Bachelor of Technology</span>
						<span className="right">
							<strong />
						</span>
					</div>
				</div>
			</section>
		</section>
		<section id="employment">
			<h2>Employment</h2>
			<section>
				<div className="jobtable">
					<div className="tablerow">
						<span className="jobtitle">
							<strong>Software Engineering Intern</strong>
						</span>
						<span className="right">June 2018 - August 2018</span>
					</div>
					<div className="tablerow">
						<span>Walgreens</span>
						<span className="right">Chicago, IL</span>
					</div>
				</div>
				<ul>
					<li>
						Developer for Rx Renewal’s data integration team undertaking world's
						largest pharmacy renewal program (150 million patients and 12
						million prescribers).
					</li>
					<li>
						Built a Spring Boot RESTful micro service that invokes a SOAP-based
						service-broker to search prescriptions from IC+ DB.
					</li>
					<li>
						Devised a client application with Angular 5 that uses REST API to
						search and display the Rx records in the dashboard.
					</li>
					<li>
						Developed ETL jobs to extract and transform GBs of data and upload
						to Kafka topics on the cluster.
					</li>
				</ul>
			</section>
			<section>
				<div className="jobtable">
					<div className="tablerow">
						<span className="jobtitle">
							<strong>Student Web Developer</strong>
						</span>
						<span className="right">October 2017 - Present</span>
					</div>
					<div className="tablerow">
						<span>Herberger Institute for Design and the Arts, ASU</span>
						<span className="right">Tempe, AZ</span>
					</div>
				</div>
				<ul>
					<li>
						Responsible for developing and delivering a multitude of web
						application projects for ASU’s design and arts school.
					</li>
					<li>
						Built a .NET MVC application to help ASU students prevent sexual
						violence by using their unique skills and perspectives.
					</li>
					<li>
						Developed a musician referral system to connect local event
						organizers with students and hire those with matching skills.
					</li>
					<li>
						Working in a fast-paced Agile Scrum environment with daily stand-up
						meetings.
					</li>
				</ul>
			</section>
			<section>
				<div className="jobtable">
					<div className="tablerow">
						<span className="jobtitle">
							<strong>Software Engineer Intern</strong>
						</span>
						<span className="right">May 2016 - July 2016</span>
					</div>
					<div className="tablerow">
						<span>Shamuka Software Inc.</span>
						<span className="right">San Francisco, CA</span>
					</div>
				</div>
				<ul>
					<li>
						Developed a Web App for scheduling, forum, and pricing for fitness
						studios based in San Francisco.
					</li>
					<li>
						Implemented the front-end components of the application using
						React.js and used Redux to maintain application state..
					</li>
					<li>
						Used REST API to parse objects from JSON hosted in an AWS
						environment.
					</li>
					<li>
						Added authentication components using OAuth from social login APIs.
					</li>
					<li>
						Documented the software requirements specifications for the
						application.
					</li>
				</ul>
			</section>
		</section>
		<section>
			<h2>Technical Skills</h2>
			<div className="table-responsive" style={{ width: '80%' }}>
				<table className="table table-bordered table-striped">
					<tbody>
						<tr>
							<td>Programming</td>
							<td className="col-md-6">Java, Python, C++</td>
						</tr>
						<tr>
							<td>Web/Scripting</td>
							<td>JavaScript, HTML5, CSS3, PHP, AJAX, XML, REST Services</td>
						</tr>
						<tr>
							<td>Frameworks</td>
							<td>React, Redux, Node.js, Spring Boot, Bootstrap, Android</td>
						</tr>
						<tr>
							<td>Big Data Technologies</td>
							<td>Map Reduce, Hadoop, Spark, Kafka</td>
						</tr>
						<tr>
							<td>Database</td>
							<td>MySQL, Oracle 11g, MongoDB, PostgreSQL</td>
						</tr>
						<tr>
							<td>Tools</td>
							<td>
								Git, Bash, Eclipse, Talend, Maven, VS Code, Android Studio,
								OpenStack
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</section>
		<section id="online">
			<br />
			<h2>Projects</h2>
			<dl clasName="row">
				<dt>Predicting user retention in Question Answering Forums </dt>
				<dd>
					Used Stack Overflow dataset to extract features that indicate when a
					user is likely to leave the forum. Compared respective performance of
					Decision Trees and SVM. Calculated the long-term value a post can add
					to the QA forum.
					<br />
					Technology: Python, scikit-learn, numpy.
					<br />
					GitHub: https://github.com/ipratikmishra/sof_user_churn
				</dd>
			</dl>
			<dl clasName="row">
				<dt>Identifying Hotspots in New York using Distributed Database</dt>
				<dd>
					Application of spatial statistics to spatiotemporal big data to
					identify hotspots of taxis around New York city using Apache Spark and
					Hadoop.
					<br />
					Technology: Java, Scala, Spark, Hadoop.
				</dd>
			</dl>
			<div className="pagebreak" />
			<dl clasName="row">
				<dt>BraiNet - Privacy management Android App</dt>
				<dd>
					Android application that uses brain signals through a brain sensor for
					authentication in smartphones. Similar to Face ID in iPhone X but
					instead of using face image the application uses brain signals.
					<br />
					Technology: Android, Java, SQLite, XML.
					<br />
					GitHub: https://github.com/ipratikmishra/BraiNet
				</dd>
			</dl>
			<div className="pagebreak" />
			<dl clasName="row">
				<dt>Gesture Recognition System for American Sign Language</dt>
				<dd>
					Implemented a feature extraction and feature deduction from the
					dataset obtained from various sensors of a MYO wristband like
					accelerometer, gyroscope, EMG and orientation sensors for each
					gesture. A model was created, trained and tested with data to
					recognize over 20 ASL symbols.
				</dd>
			</dl>
			<div className="pagebreak" />
			<dl clasName="row">
				<dt>PatientTracker Android App (Spring 2017) </dt>
				<dd>
					Developed a health management android application to track patient
					health records like various illnesses, medicines prescribed and other
					vital records that can be used by a doctor to perform diagnostics.
					<br />
					Technology: Java, SQLite, AJAX, DropBox API, XML.
					<br />
					Github: https://github.com/ipratikmishra/PatientTracker
				</dd>
			</dl>
			<div className="pagebreak" />
			<dl clasName="row">
				<dt>Faculty Management Website</dt>
				<dd>
					Developed a dynamic website for faculty registration and content
					management using JavaScript and PHP. Queried a MySQL database to
					generate information to be shown in the website.
					<br />
					Technology: HTML5, CSS3, PHP, JavaScript, MySQL, Bootstrap.
					<br />Github: https://github.com/ipratikmishra/iiit-faculty-managament
				</dd>
			</dl>
		</section>
	</div>
);

export default Resume;



// WEBPACK FOOTER //
// ./src/components/Resume.js